module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/costume_03-9bac8a259eb7fe352de03d3b3f94e771.webp";